import ComposeViewState from '../store/schema/ComposeViewState';
import { FloatingType } from '../store/schema/FloatingViewState';
import { getStore } from '../store/composeStore';
import upConvert from './upConvert';
import { action } from 'satcheljs/lib/legacy';

export default action('floatCompose')(function(viewState: ComposeViewState, type: FloatingType) {
    if (!viewState) {
        return;
    }

    const store = getStore();
    const composeId = viewState.composeId;

    // floatCompose can put any composeViewState into floatingViewStates and set its floating type
    // if the viewState is primary/pending originally, need to remove it
    if (composeId == store.primaryComposeId) {
        store.primaryComposeId = null;
    } else if (composeId == store.pendingComposeId) {
        store.pendingComposeId = null;
    }

    // Only support full compose in floating mode for now. If it is inline compose, upConvert to full compose
    if (viewState.isInlineCompose) {
        upConvert(viewState);
    }

    // Don't use async send for floating compose since there can be multiple floating compose
    viewState.preferAsyncSend = false;

    // add the viewState into floatingViewStates if it is not there
    let floatingViewState = store.floatingViewStates.get(viewState.composeId);

    if (!floatingViewState) {
        floatingViewState = {
            type: FloatingType.Normal,
            zIndex: 0,
            composeId: composeId,
        };
        store.floatingViewStates.set(viewState.composeId, floatingViewState);
    }

    floatingViewState.type = type;
});
